import { create } from 'zustand';

interface BoostConfig {
  id: string;
  name: string;
  startDate: Date;
  endDate: Date;
}

interface BoostState {
  boosts: BoostConfig[];
  remainingSeconds: number;
  getActiveBoost: () => BoostConfig | undefined;
  isBoostActive: () => boolean;
  tick: () => void;
  initCountdown: () => void;
  getTotalSeconds: () => number;
}

const boosts: BoostConfig[] = [
  {
    id: 'valentine-2026',
    name: 'valentine',
    startDate: new Date(2026, 1, 14, 0, 0, 0),
    endDate: new Date(2026, 1, 14, 23, 59, 59)
  }
];

export const useBoostStore = create<BoostState>((set, get) => ({
  boosts,
  remainingSeconds: 0,

  getActiveBoost: () => {
    const now = new Date();
    return get().boosts.find((b) => now >= b.startDate && now <= b.endDate);
  },

  isBoostActive: () => !!get().getActiveBoost(),

  initCountdown: () => {
    const boost = get().getActiveBoost();
    if (!boost) {
      set({ remainingSeconds: 0 });
      return;
    }
    const remaining = Math.max(
      0,
      Math.floor((boost.endDate.getTime() - Date.now()) / 1000)
    );
    set({ remainingSeconds: remaining });
  },

  tick: () => {
    set((state) => ({
      remainingSeconds: Math.max(0, state.remainingSeconds - 1)
    }));
  },

  getTotalSeconds: () => {
    const boost = get().getActiveBoost();
    if (!boost) return 0;
    return Math.floor(
      (boost.endDate.getTime() - boost.startDate.getTime()) / 1000
    );
  }
}));